var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { ProjectObjectType } from "@@/Project";
import { action, makeObservable, observable } from "mobx";
import { FileUploadDialogState } from "@/app/UIComponents/FileUploadDialog";
import { ProjectNewFolderState } from "@/app/UIComponents/ProjectNewFolder";
import { BookmarkState } from "@/app/UIComponents/BookmarkDialog";
import { ObjectRenameState } from "@/app/UIComponents/ProjectObjectRenameDialog";
import { LetrRequestType } from "@/share/Letr";
import { SearchDataType } from "@@/ModuleJob";
import { AccessGroupState } from "@/app/uistore/AccessgroupState";
import { ExpandableTreeState } from "@/app/UIComponents/ExpandableTree";
import { TableRenderState } from "@/app/uistore/TableRenderState";
import { formatBytes } from "@@/Util";
import { DateLib } from "@@/Datelib";
export const ROOTFolder = "root";
export const TRASHFolder = "trash";
export var UpdateType;
(function (UpdateType) {
    UpdateType[UpdateType["Rename"] = 0] = "Rename";
    UpdateType[UpdateType["None"] = 1] = "None";
})(UpdateType || (UpdateType = {}));
export class AdminProjectUIStore {
    constructor() {
        this.projectsobject = new Map();
        this.searchstore = new Map();
        this.actvefolderselectitem = new Set();
        this.loading = false;
        this.activeletrid = "";
        this.activefolderid = "";
        this.openactionmenu = false;
        this.selecteditems = new Set();
        this.trashing = false;
        this.showsearchresult = false;
        this.fullfolderselected = new Set();
        this.updatetype = UpdateType.None;
        this.copyitems = new Set();
        this.cutitems = new Set();
        this.cutItemsProjectObject = new Map();
        this.copyItemsProjectObject = new Map();
        this.cutpasting = false;
        this.copypasting = false;
        this.recovering = false;
        this.emptytrashing = false;
        this.updatesecondpanel = false;
        this.searchactive = false;
        this.searching = false;
        this.searchterm = "";
        this.foundmsg = "";
        this.searchprogressmessage = "";
        this.activeitemid = ""; // this is the item showing in right panel
        this.loadingmoresearch = false;
        this.searchmatches = [];
        this.renamestate = new ObjectRenameState();
        this.ongoingcreaterequests = 0;
        this.memberDetail = [];
        this.activeuserid = "";
        this.showdropzone = false;
        this.selectedFolder = [
            {
                folderid: ROOTFolder,
                name: "Home",
                index: 0
            }
        ];
        this.newfolderstate = new ProjectNewFolderState();
        this.fileuploadstate = new FileUploadDialogState();
        this.bookmarkstate = new BookmarkState();
        this.accessstorestate = new AccessGroupState();
        this.loadState = -1;
        this.vieweractive = false;
        this.folders = new Map();
        this.projecttreestate = new ExpandableTreeState();
        this.filterfolderterm = "";
        this.atimeout = undefined;
        this.loadedfolder = -1;
        this.documentTableState = new TableRenderState();
        this.metaitems = new Map();
        this.cview = [];
        this.hidecoilumn = new Set();
        makeObservable(this);
        // this.documentTableState.addHeaders([
        //     { label: 'Name', id: 'name', index: 0, width: (window.innerWidth * .75) / 2 },
        //     { label: 'Type', id: 'type', index: 1, width: (window.innerWidth * .75 / 2) / 3.2 },
        //     { label: 'Size', id: 'size', index: 2, width: (window.innerWidth * .75 / 2) / 3.2 },
        //     { label: 'Last Modified', id: 'lastmodified', index: 3, width: window.innerWidth * .75 / 2 / 3.2 }]);
        this.addHeaders();
        APPEvent.addSubscriberForProjectObjectDetails((res) => {
            if (res.letrid === this.activeletrid && res.reqid === this.searchterm) {
                res.objs.forEach((obj) => {
                    this.addSearchResult(obj);
                });
                this.setSearching(false);
                this.setLoadingMoreSearch(false);
            }
        });
        APPEvent.addSubscriberForSearchMatchResp((res) => {
            if (this.searching && res.letrid === this.activeletrid && res.searchtext === this.searchterm) {
                if (res.matches === undefined) {
                    this.documentTableState.clearRows();
                    this.projecttreestate.hideAll();
                    this.setSearching(false);
                    this.setSearchFoundMessage("No matches");
                }
                else {
                    const pids = new Set();
                    for (const re of res.matches.result) {
                        for (const d of re.indexdata) {
                            pids.add(d.itemid);
                        }
                    }
                    if (pids.size === 0) {
                        this.documentTableState.clearRows();
                        this.projecttreestate.hideAll();
                        this.setSearching(false);
                        this.setSearchFoundMessage("No matches");
                    }
                    else {
                        this.setSearchFoundMessage(pids.size + " match" + (pids.size > 1 ? "es" : ""));
                        // we should fist download all the parents and then maybe we should show the result
                        this.downloadParentForObjects(Array.from(pids));
                        this.searchmatches = Array.from(pids);
                        /*
                        this.setSearchProgess("Downloading object" + (pids.size > 1 ? "s" : "") + "...");
                        
                        const req: ProjectIdDetailRequest = {
                            letrid: this.activeletrid,
                            ids: this.searchmatches.splice(0, 50),
                            reqid: this.searchterm
                        };

                        Apphandler.sendMessage("driveprojectids", req);*/
                    }
                }
            }
        });
        APPEvent.addSubscriberForAdminObjectParentFolder((res) => {
            if (this.searching && res.letrid === this.activeletrid && res.id === this.searchterm) {
                // now we have everything to display our result
                // we need to hide all folders and only show the parent tree stuff
                // on click we can just display the matching reuslt 
                this.setActiveFolderId("");
                this.documentTableState.clearRows();
                this.projecttreestate.hideAll();
                this.showSearchParentResult(res.parent);
                this.setSearching(false);
            }
        });
        APPEvent.addSubscriberForProjectObject((obj) => {
            this.addProjectObject(obj);
        });
        APPEvent.addSubscriberForEmptyTrash((em) => {
            if (this.emptytrashing) {
                if (em) {
                    this.clearTrash();
                }
                this.setEmptyTrashing(false);
            }
        });
        APPEvent.addSubscriberForActiveLetr((lt) => {
            this.setActiveLetr(lt);
        });
        APPEvent.addSubscriberForLetrsResponse((res) => {
            if (res.type === LetrRequestType.FetchDetail && res.letrdetail !== undefined) {
                if (this.activeletrid === res.letrid) {
                    // lets keeo the 
                    this.memberDetail = res.letrdetail.memberDetails;
                }
            }
        });
        APPEvent.addSubscriberForAdminProjectObjectRes((prjs) => {
            if (this.loading) {
                if (this.activeletrid === prjs.letrid && this.activefolderid === prjs.parentid) {
                    this.addProjectObjects(prjs.projects);
                    this.setLoading(false);
                }
            }
        });
        APPEvent.addSubscriberForUpdateObject((up) => {
            if (this.updatetype !== UpdateType.None) {
                if (this.updatetype === UpdateType.Rename) {
                    if (up.project !== undefined && up.success) {
                        // okay we should just update the po and then we done 
                        // all we need is look for this object that's it
                        this.projectsobject.set(up.project.id, up.project);
                        this.renamestate.setOpen(false);
                    }
                    else {
                        this.renamestate.setError("Sorry, failed to rename please try again later");
                        this.renamestate.setLoading(false);
                    }
                }
                this.updatetype = UpdateType.None;
            }
        });
        APPEvent.addSubscriberForMoveObject((ob) => {
            if (this.cutpasting && this.cutitems.size > 0) {
                const ids = ob.project;
                for (const id of ids) {
                    const po = this.cutItemsProjectObject.get(id);
                    if (po !== undefined) {
                        po.parentid = this.activefolderid;
                        this.addProjectObject(po);
                    }
                }
                this.cutitems.forEach((it) => this.setObjectSelection(it, false));
                this.setCutPasting(false);
                this.resetCutItems();
            }
            else if ((this.trashing || this.recovering) && this.selecteditems.size > 0) {
                this.selecteditems.forEach((id) => this.removeItemFromProjectObject(id));
                this.clearSelectedItems();
                this.setTrashing(false);
                this.setRecovering(false);
            }
        });
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.activeuserid = useird;
        });
        APPEvent.addSubscriberForProjectFolders((folder) => {
            if (folder.letrid === this.activeletrid && !folder.isChooser) {
                this.setFolders(folder.folders);
            }
        });
        APPEvent.addSubscriberForAdminLetrChanged((letr) => {
            this.setActiveLetr(letr.id);
            if (this.activefolderid === "") {
                this.setActiveFolderId(ROOTFolder);
            }
            this.loadAllFolders();
        });
        APPEvent.addSubcriberForAdminGetMetadataa((res) => {
            if (res.isChooser || res.userid !== this.activeuserid || res.letrid !== this.activeletrid) {
                return;
            }
            const meta = res.data;
            this.clearMetadata();
            for (const mt of meta) {
                if (mt.letrid === this.activeletrid) {
                    this.addMetadata(mt);
                }
            }
            this.addHeaders();
        });
    }
    clearMetadata() {
        this.metaitems.clear();
    }
    addMetadata(mt) {
        this.metaitems.set(mt.id, mt);
    }
    addHeaders() {
        this.documentTableState.clearHeaders();
        const rows = this.documentTableState.getRows();
        this.documentTableState.clearRows();
        this.documentTableState.addHeaders([
            { label: 'Name', id: 'name', index: 0, width: (window.innerWidth * .75) / 2 },
            { label: 'Type', id: 'type', index: 1, width: (window.innerWidth * .75 / 2) / 3.2 },
            { label: 'Size', id: 'size', index: 2, width: (window.innerWidth * .75 / 2) / 3.2 },
            { label: 'Last Modified', id: 'lastmodified', index: 3, width: window.innerWidth * .75 / 2 / 3.2 }
        ].filter((sh) => !this.hidecoilumn.has(sh.id)));
        if (this.metaitems.size > 0) {
            const mitems = this.getMetadata();
            this.documentTableState.addHeaders(mitems.filter((mitem) => !this.hidecoilumn.has(mitem.id)).map((mitem, index) => {
                const ret = {
                    label: mitem.name,
                    id: "custom_" + mitem.id,
                    index: index + 4,
                    width: 400
                };
                return ret;
            }));
        }
        this.addColumnViews();
        this.addProjectObjects(Array.from(this.projectsobject.values()));
    }
    getMetadata() {
        return Array.from(this.metaitems.values()).slice().sort((m1, m2) => m1.orderindex - m2.orderindex);
    }
    addColumnViews() {
        var _a, _b, _c, _d;
        const lcopy = this.cview;
        this.cview.splice(0, this.cview.length);
        const lmap = new Map();
        lcopy.forEach((lc) => lmap.set(lc.id, lc.hidden));
        const sview = [{ label: 'Name', id: 'name', hidden: (_a = lmap.get("name")) !== null && _a !== void 0 ? _a : false },
            { label: 'Type', id: 'type', hidden: (_b = lmap.get("type")) !== null && _b !== void 0 ? _b : false },
            { label: 'Size', id: 'size', hidden: (_c = lmap.get("size")) !== null && _c !== void 0 ? _c : false },
            { label: 'Last Modified', id: 'lastmodified', hidden: (_d = lmap.get("lastmodified")) !== null && _d !== void 0 ? _d : false }];
        this.cview.push(...sview);
        if (this.metaitems.size > 0) {
            const mitems = this.getMetadata();
            mitems.forEach((mi) => { var _a; return this.cview.push({ label: mi.name, id: mi.id, hidden: (_a = lmap.get(mi.id)) !== null && _a !== void 0 ? _a : false }); });
        }
    }
    showSearchParentResult(objs) {
        let showparentwithcount = new Map();
        // now lets calcualte everything and we done here!!
        for (const obj of objs) {
            let count = 1;
            if (showparentwithcount.has(obj.parentid)) {
                const sj = showparentwithcount.get(obj.parentid);
                if (sj !== undefined) {
                    count = sj + 1;
                }
            }
            showparentwithcount.set(obj.parentid, count);
        }
        this.projecttreestate.hideOrShowItems(ROOTFolder, false);
        for (const [k, count] of showparentwithcount) {
            this.projecttreestate.hideOrShowItems(k, false);
            this.projecttreestate.updateCount(k, count);
            const folder = this.folders.get(k);
            if (folder !== undefined) {
                let parent = folder.parentid;
                while (parent !== ROOTFolder) {
                    this.projecttreestate.hideOrShowItems(parent, false);
                    if (!showparentwithcount.has(parent)) {
                        this.projecttreestate.updateCount(k, 0);
                    }
                    const folder = this.folders.get(parent);
                    if (folder === undefined) {
                        break;
                    }
                    parent = folder.parentid;
                }
            }
        }
    }
    removeItemFromUI(ob) {
        if (ob.type === ProjectObjectType.Folder) {
            const f = ob;
            this.projecttreestate.removeChild({
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: f.childrencount
            });
        }
        else {
            this.documentTableState.removeRow(ob.id);
        }
        this.projecttreestate.increamentCount(-1, ob.parentid);
    }
    updateUIObject(ob) {
        if (ob.type === ProjectObjectType.Folder) {
            const f = ob;
            this.projecttreestate.updateNode({
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: f.childrencount
            });
        }
        else {
            const robj = this.makeObjectForTable(ob);
            if (robj !== undefined) {
                this.documentTableState.replaceRow(robj);
            }
        }
    }
    async downloadParentForObjects(ids) {
        const req = {
            letrid: this.activeletrid,
            ids: ids,
            reqid: this.searchterm
        };
        Apphandler.sendMessage("getobjectparents", req);
    }
    makeObjectForTable(ob) {
        this.projectsobject.set(ob.id, ob);
        if (this.selecteditems.has(ob.id)) {
            this.actvefolderselectitem.add(ob.id);
        }
        if (ob.type !== ProjectObjectType.Folder) {
            const dcol = [];
            if (!this.hidecoilumn.has("name")) {
                dcol.push({ id: ob.id + "_name", data: ob.name });
            }
            if (!this.hidecoilumn.has("type")) {
                dcol.push({
                    id: ob.id + "_type", data: ob.type, type: ob.type,
                    drafttype: ob.type === ProjectObjectType.Draft ? ob.drafttype : undefined
                });
            }
            if (!this.hidecoilumn.has("size")) {
                dcol.push({ id: ob.id + "_size", data: this.getSize(ob) });
            }
            if (!this.hidecoilumn.has("lastmodified")) {
                dcol.push({ id: ob.id + "_mod", data: this.getModified(ob) });
            }
            this.getMetadata().forEach((mt) => {
                if (!this.hidecoilumn.has(mt.id)) {
                    dcol.push({
                        id: "custom_" + mt.id,
                        data: "",
                    });
                }
            });
            return {
                rowindex: 0,
                row: dcol,
                id: ob.id
            };
        }
        return undefined;
    }
    getSize(ob) {
        if (ob.type === ProjectObjectType.Document) {
            const dob = ob;
            return formatBytes(dob.size);
        }
        else if (ob.type === ProjectObjectType.Folder) {
            const fob = ob;
            return fob.childrencount + " item" + (fob.childrencount > 1 ? 's' : '');
        }
        return "";
    }
    getModified(ob) {
        return DateLib.displayDate(ob.updatetime);
    }
    setFolders(folder) {
        const nodes = [];
        folder.forEach((f) => {
            const fobj = f;
            this.addFolder(fobj);
            const treenode = {
                id: f.id,
                children: [],
                label: f.name,
                parentid: f.parentid,
                displaycount: fobj.childrencount,
                color: fobj.color
            };
            nodes.push(treenode);
        });
        nodes.push({
            id: ROOTFolder,
            label: 'Home',
            children: [],
            parentid: this.projecttreestate.ROOTID
        });
        this.projecttreestate.setNodes(nodes);
        this.projecttreestate.setExpandedNode(ROOTFolder, true);
    }
    addFolder(folder) {
        this.folders.set(folder.id, folder);
    }
    removeFolder(id) {
        this.folders.delete(id);
    }
    dofilterFolders() {
        if (this.atimeout) {
            clearTimeout(this.atimeout);
        }
        this.atimeout = setTimeout(() => {
            if (!this.filterfolderterm) {
                this.projecttreestate.showAll();
                return;
            }
            // lets try filtering these items now!!
            const items = Array.from(this.folders.values()).filter((fol) => fol.name.toLowerCase().indexOf(this.filterfolderterm) !== -1);
            this.projecttreestate.hideAll();
            if (items.length === 0) {
            }
            else {
                this.projecttreestate.hideOrShowItems(ROOTFolder, false);
                // lets show these items and their parent
                for (const item of items) {
                    this.projecttreestate.hideOrShowItems(item.id, false);
                    let parent = item.parentid;
                    while (parent !== ROOTFolder) {
                        const pf = this.folders.get(parent);
                        if (pf === undefined) {
                            break;
                        }
                        this.projecttreestate.hideOrShowItems(parent, false);
                        parent = pf === null || pf === void 0 ? void 0 : pf.parentid;
                    }
                }
            }
        }, 50);
    }
    setFilterFolderTerm(term) {
        this.filterfolderterm = term.trim();
        this.dofilterFolders();
    }
    setViewerActive(active) {
        this.vieweractive = active;
    }
    showDropZone(show) {
        this.showdropzone = show;
    }
    resetSelctedFolders() {
        this.selectedFolder = [];
    }
    setShowSearchResult(show) {
        this.showsearchresult = show;
    }
    setLoadingMoreSearch(loading) {
        this.loadingmoresearch = loading;
    }
    loadMoreSearch() {
        if (this.searchmatches.length > 0) {
            const req = {
                letrid: this.activeletrid,
                ids: this.searchmatches.splice(0, 50),
                reqid: this.searchterm
            };
            this.setLoadingMoreSearch(true);
            Apphandler.sendMessage("driveprojectids", req);
        }
        else {
            this.setLoadingMoreSearch(false);
        }
    }
    setSearchFoundMessage(msg) {
        this.foundmsg = msg;
    }
    setSearchProgess(msg) {
        this.searchprogressmessage = msg;
    }
    addSearchResult(res) {
        this.searchstore.set(res.id, res);
    }
    resetSearch() {
        this.setSearching(false);
        this.setSearchActive(false);
        this.setSearchTerm("");
        this.searchstore.clear();
        this.setSearchProgess("");
        this.setSearchFoundMessage("");
        this.setShowSearchResult(false);
        this.setLoadingMoreSearch(false);
        this.setActiveFolderId("");
    }
    performSearch() {
        if (!this.searchterm.trim()) {
            return;
        }
        this.resetSelctedFolders();
        this.searchstore.clear();
        this.setSearchProgess("Searching encrypted database...");
        this.setSearchFoundMessage("");
        this.setSearchActive(true);
        this.setShowSearchResult(true);
        this.setSearching(true);
        const req = {
            letrid: this.activeletrid,
            searchtext: this.searchterm,
            type: SearchDataType.DriveName,
            mfilter: []
        };
        Apphandler.sendMessage("searchdrive", req);
    }
    setSearching(searching) {
        this.searching = searching;
    }
    setSearchActive(active) {
        this.searchactive = active;
    }
    setSearchTerm(term) {
        this.searchterm = term;
    }
    setActiveItemid(id) {
        this.activeitemid = id;
        if (!id) {
            this.documentTableState.setSelectId("");
        }
    }
    setEmptyTrashing(em) {
        this.emptytrashing = em;
    }
    setUpdateSecondPanel(update) {
        this.updatesecondpanel = update;
    }
    setRecovering(rc) {
        this.recovering = rc;
    }
    setTrashing(ts) {
        this.trashing = ts;
    }
    setCutPasting(pasting) {
        this.cutpasting = pasting;
    }
    setCopyPasting(pasting) {
        this.copypasting = pasting;
    }
    clearTrash() {
        this.projectsobject.clear();
        this.clearSelectedItems();
    }
    setActiveFolderSelection(sel) {
        if (sel) {
            this.fullfolderselected.add(this.activefolderid);
        }
        else {
            this.fullfolderselected.delete(this.activefolderid);
        }
        this.projectsobject.forEach((val, key) => this.setObjectSelection(key, sel));
    }
    clearSelectedItems() {
        this.selecteditems.clear();
        this.actvefolderselectitem.clear();
        this.fullfolderselected.clear();
    }
    setObjectSelection(id, sel) {
        if (sel) {
            this.selecteditems.add(id);
            if (this.projectsobject.has(id)) {
                this.actvefolderselectitem.add(id);
            }
        }
        else {
            this.selecteditems.delete(id);
            if (this.projectsobject.has(id)) {
                this.actvefolderselectitem.delete(id);
            }
            if (this.actvefolderselectitem.size === 0) {
                this.fullfolderselected.delete(this.activefolderid);
            }
        }
    }
    removeItemFromProjectObject(id) {
        this.projectsobject.delete(id);
    }
    setOpenActionMenu(open) {
        this.openactionmenu = open;
    }
    addSelected(name, id) {
        this.selectedFolder.push({ folderid: id, name: name, index: this.selectedFolder.length });
    }
    removeTill(index) {
        for (let i = this.selectedFolder.length - 1; i > index; i--) {
            this.selectedFolder.pop();
        }
        const last = this.selectedFolder[this.selectedFolder.length - 1];
        this.setActiveFolderId(last.folderid);
        this.loadFolderContent();
    }
    addProjectObject(obj) {
        if (obj.parentid === this.activefolderid) {
            this.projectsobject.set(obj.id, obj);
            const robj = this.makeObjectForTable(obj);
            if (robj !== undefined) {
                robj.rowindex = this.documentTableState.row.size;
                this.documentTableState.addRow(robj);
            }
        }
        if (obj.type === ProjectObjectType.Folder) {
            const fobj = obj;
            this.addFolder(fobj);
            const treenode = {
                id: obj.id,
                children: [],
                label: obj.name,
                parentid: obj.parentid,
                color: fobj.color,
                displaycount: (fobj).childrencount
            };
            this.projecttreestate.addChild(treenode);
        }
        if (obj.parentid !== ROOTFolder && obj.parentid !== TRASHFolder) {
            this.projecttreestate.increamentCount(1, obj.parentid);
        }
    }
    getProjectObject(id) {
        return this.projectsobject.get(id);
    }
    resetProjectObjects() {
        this.projectsobject.clear();
    }
    addProjectObjects(objs) {
        const drows = [];
        objs.forEach((ob, index) => {
            let add = true;
            if (this.searchactive) {
                const index = this.searchmatches.indexOf(ob.id);
                if (index > -1) {
                    add = true;
                }
                else {
                    add = false;
                }
            }
            if (add) {
                const robj = this.makeObjectForTable(ob);
                if (robj !== undefined) {
                    robj.rowindex = index;
                    drows.push(robj);
                }
            }
        });
        this.documentTableState.addRows(drows);
    }
    setActiveFolderId(id) {
        if (id === this.activefolderid) {
            return;
        }
        this.setShowSearchResult(false);
        // this.resetProjectObjects();
        this.actvefolderselectitem.clear();
        this.documentTableState.clearRows();
        this.activefolderid = id;
        this.loadFolderContent();
    }
    loadAllFolders() {
        if (this.loadedfolder === 1 || !this.activeletrid) {
            return;
        }
        this.projecttreestate.setArranging(true);
        this.loadedfolder = 1;
        const req = { letrid: this.activeletrid, isChooser: false, userid: this.activeuserid };
        Apphandler.sendMessage("admingetprojectfolder", req);
    }
    loadFolderContent() {
        if (this.loading || !this.activefolderid) {
            return;
        }
        this.setLoading(true);
        const req = {
            letrid: this.activeletrid,
            parentid: this.activefolderid,
            userid: this.activeuserid
        };
        Apphandler.sendMessage("admingetproject", req);
    }
    setActiveLetr(id) {
        if (this.atimeout) {
            clearTimeout(this.atimeout);
        }
        this.projecttreestate.reset();
        this.memberDetail = [];
        this.activeletrid = id;
        this.loadState = -1;
        this.setActiveFolderId("");
        this.selectedFolder.splice(1, this.selectedFolder.length);
        this.setLoading(false);
        this.selecteditems.clear();
        this.fullfolderselected.clear();
        this.actvefolderselectitem.clear();
        this.resetCopyItems();
        this.resetCutItems();
        this.loadedfolder = -1;
        this.resetSearch();
        this.folders.clear();
        this.showDropZone(false);
    }
    addToCutItems(id) {
        const po = this.projectsobject.get(id);
        if (po === undefined) {
            return;
        }
        this.cutitems.add(id);
        this.cutItemsProjectObject.set(id, po);
    }
    performCut() {
        if (this.cutpasting) {
            return;
        }
        if (this.cutitems.size > 0) {
            this.setCutPasting(true);
            this.moveItems(Array.from(this.cutitems), this.activefolderid);
        }
    }
    moveItems(items, newparentid) {
        const req = {
            letrid: this.activeletrid,
            project: items,
            newparentid: newparentid
        };
        Apphandler.sendMessage("moveobject", req);
    }
    performCopy() {
        if (this.copypasting) {
            return;
        }
        if (this.copyitems.size > 0) {
            this.setCopyPasting(true);
            for (const [item, po] of this.copyItemsProjectObject) {
                const req = {
                    letrid: this.activeletrid,
                    project: Object.assign(Object.assign({}, po), { parentid: this.activefolderid }),
                    iscopy: true,
                    mainitemid: po.id
                };
                this.ongoingcreaterequests++;
                Apphandler.sendMessage("createproject", req);
            }
        }
    }
    emptyTrash() {
        this.setEmptyTrashing(true);
        Apphandler.sendMessage("emptytrash", this.activeletrid);
    }
    showHome(clearsel = true) {
        if (clearsel) {
            this.clearSelectedItems();
        }
        this.setActiveFolderId(ROOTFolder);
        this.selectedFolder = [];
        this.selectedFolder[0] = {
            folderid: ROOTFolder,
            name: "Home",
            index: 0
        };
    }
    showTrash() {
        this.clearSelectedItems();
        this.setActiveFolderId(TRASHFolder);
        this.selectedFolder = [];
        this.selectedFolder[0] = {
            folderid: TRASHFolder,
            name: "Trash",
            index: 0
        };
    }
    recover() {
        if (this.selecteditems.size === 0) {
            return;
        }
        this.setRecovering(true);
        this.moveItems(Array.from(this.selecteditems), ROOTFolder);
    }
    trashItems() {
        if (this.selecteditems.size === 0) {
            return;
        }
        this.setTrashing(true);
        this.moveItems(Array.from(this.selecteditems), TRASHFolder);
    }
    addToCopyItems(id) {
        const po = this.projectsobject.get(id);
        // folder not allowed
        if (po === undefined || po.type === ProjectObjectType.Folder) {
            return;
        }
        this.copyitems.add(id);
        this.copyItemsProjectObject.set(id, po);
    }
    resetCutItems() {
        this.cutitems.clear();
        this.cutItemsProjectObject.clear();
    }
    resetCopyItems() {
        this.copyitems.clear();
        this.copyItemsProjectObject.clear();
    }
    setLoading(loading) {
        this.loading = loading;
    }
    getObjects() {
        let objs;
        if (this.searchactive && this.showsearchresult) {
            objs = Array.from(this.searchstore.values());
        }
        else {
            objs = Array.from(this.projectsobject.values());
        }
        return objs.sort((a, b) => {
            if (a.type !== b.type) {
                if (a.type === ProjectObjectType.Folder) {
                    return -1;
                }
                if (b.type === ProjectObjectType.Folder) {
                    return 1;
                }
            }
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminProjectUIStore.prototype, "projectsobject", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminProjectUIStore.prototype, "searchstore", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminProjectUIStore.prototype, "actvefolderselectitem", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "activeletrid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "activefolderid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "openactionmenu", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminProjectUIStore.prototype, "selecteditems", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "trashing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "showsearchresult", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminProjectUIStore.prototype, "fullfolderselected", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], AdminProjectUIStore.prototype, "updatetype", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminProjectUIStore.prototype, "copyitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminProjectUIStore.prototype, "cutitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminProjectUIStore.prototype, "cutItemsProjectObject", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminProjectUIStore.prototype, "copyItemsProjectObject", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "cutpasting", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "copypasting", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "recovering", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "emptytrashing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "updatesecondpanel", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "searchactive", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "searching", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "searchterm", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "foundmsg", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "searchprogressmessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "activeitemid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "loadingmoresearch", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminProjectUIStore.prototype, "showdropzone", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminProjectUIStore.prototype, "selectedFolder", void 0);
__decorate([
    observable,
    __metadata("design:type", Boolean)
], AdminProjectUIStore.prototype, "vieweractive", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminProjectUIStore.prototype, "folders", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminProjectUIStore.prototype, "filterfolderterm", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminProjectUIStore.prototype, "metaitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminProjectUIStore.prototype, "cview", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], AdminProjectUIStore.prototype, "hidecoilumn", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "clearMetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addMetadata", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addColumnViews", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addFolder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "removeFolder", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setFilterFolderTerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setViewerActive", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "showDropZone", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "resetSelctedFolders", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setShowSearchResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setLoadingMoreSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setSearchFoundMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setSearchProgess", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addSearchResult", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "resetSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "performSearch", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setSearching", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setSearchActive", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setSearchTerm", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setActiveItemid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setEmptyTrashing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setUpdateSecondPanel", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setRecovering", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setTrashing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setCutPasting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setCopyPasting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "clearTrash", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setActiveFolderSelection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "clearSelectedItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setObjectSelection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "removeItemFromProjectObject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setOpenActionMenu", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addSelected", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "removeTill", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addProjectObject", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "resetProjectObjects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addProjectObjects", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setActiveFolderId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setActiveLetr", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addToCutItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "showHome", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "showTrash", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "addToCopyItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "resetCutItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "resetCopyItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminProjectUIStore.prototype, "setLoading", null);
